import { MenuItem } from '@chakra-ui/react'
import { FC, useMemo, useState } from 'react'
import CsvDownloader from 'react-csv-downloader'
import { GrDocumentCsv } from 'react-icons/gr'
import { useImmer } from 'use-immer'

import useTools from '@hook/shared/use-tools'

import { parseReabSapMrpData } from '@helper/grid/mrp/reab-sap'

import { ITableHeader } from '@base/@types/components/Layout/TableGrid'
import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'
import mrpReabSapHeader from '@base/variables/headers/mrp/reab-sap'

const ActionSapReabMrpExport: FC<ILayoutToolsExportAction> = ({
  data,
  parser = parseReabSapMrpData
}) => {
  const { isDisabled } = useTools()
  const [_isLoading, setLoading] = useState(false)

  const [headers] = useImmer<ITableHeader[]>(mrpReabSapHeader)
  const columns = useMemo(() => {
    const data: any[] = []

    for (const header of headers!) {
      if (!header.columns) continue

      for (const column of header.columns) {
        if (column.show) {
          data.push({
            id: column.id,
            displayName: `${column.name}`
          })
        }
      }
    }

    return data
  }, [headers])

  const rows = useMemo(() => {
    const newData = data.filter(x => {
      if (x.estoqueQuantidadeSugerida * x.estoqueFatorConversao > 0) {
        return x
      }
    })
    const parsedData = parser(newData)

    const body = []

    for (const row of parsedData) {
      const item: any = {}

      for (const column of columns) {
        item[column.id] = row[column.id]
      }

      body.push(item)
    }

    return body
  }, [columns, data, parser])
  return (
    <CsvDownloader
      filename={'MRP-Reab'}
      columns={columns}
      datas={rows}
      separator=";"
      wrapColumnChar='"'
      bom={true}
    >
      <MenuItem
        p="2px 12px"
        fontSize="sm"
        bgColor="white"
        loading
        _hover={{ bg: 'gray.400' }}
        isDisabled={isDisabled}
        onClick={() => {
          setTimeout(() => {
            setLoading(false)
          }, 2000)
        }}
        icon={<GrDocumentCsv />}
      >
        Exportar para SAP/Viasoft
      </MenuItem>
    </CsvDownloader>
  )
}

export default ActionSapReabMrpExport
